import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTableCell = styled(TableCell)(({ theme }) => {
  const isLight = theme.palette.mode === 'light';
  const bg = isLight ? theme.palette.grey[200] : theme.palette.grey[800];
  return {
    backgroundColor: bg,
    color: isLight ? theme.palette.text.primary : theme.palette.getContrastText(bg),
    textAlign: 'center',
    padding: '4px',
    fontSize: '0.875rem',
    borderColor: theme.palette.divider,
  };
});

const HeaderTableCell = styled(TableCell)({
  fontWeight: 'bold',
  textAlign: 'center',
  padding: '4px',
  fontSize: '0.875rem',
});

// Display für die volle Stunde und die halbe Stunde
const HourDisplay = ({ time, isHalfHour }) => {
  if (isHalfHour) {
    return (
      <Typography
        component='span'
        variant='body2'
        sx={{ fontSize: '0.75rem', verticalAlign: 'text-bottom' }}
      >
        30
      </Typography>
    );
  }
  return (
    <Typography component='span' variant='body1' sx={{ fontWeight: 'bold' }}>
      {time.split(':')[0]}
    </Typography>
  );
};

const WorktimeTimeline = ({ worktimes }) => {
  const { mainTimes, earlyTimes, lateTimes } = worktimes;

  return (
    <TableContainer component={Paper}>
      <Table
        sx={{ width: '100%', tableLayout: 'fixed', minWidth: '850px' }}
        aria-label='worktime table'
      >
        <TableHead>
          <TableRow>
            <TableCell colSpan={mainTimes.length + 1}>
              <Typography variant='h6' sx={{ fontSize: '1.25rem' }}>
                {worktimes.branchName}
              </Typography>
              <Typography variant='subtitle2' sx={{ fontSize: '0.875rem' }}>
                Stunden: {worktimes.hourSum.toFixed(2)} | Pausen: {worktimes.pauseSum.toFixed(2)}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <HeaderTableCell></HeaderTableCell>
            {mainTimes.map((slot, index) => (
              <StyledTableCell key={index}>
                <HourDisplay time={slot.time} isHalfHour={slot.time.includes('30')} />
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <HeaderTableCell>L</HeaderTableCell>
            {mainTimes.map((slot, index) => (
              <StyledTableCell key={index}>{slot.Arenaleitung}</StyledTableCell>
            ))}
          </TableRow>
          <TableRow>
            <HeaderTableCell>K</HeaderTableCell>
            {mainTimes.map((slot, index) => (
              <StyledTableCell key={index}>{slot.Kundenbetreuung}</StyledTableCell>
            ))}
          </TableRow>
          <TableRow>
            <HeaderTableCell>Σ</HeaderTableCell>
            {mainTimes.map((slot, index) => (
              <StyledTableCell key={index}>
                <b>{slot.Arenaleitung + slot.Kundenbetreuung}</b>
              </StyledTableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
      <Table
        sx={{ width: '100%', tableLayout: 'fixed', minWidth: '850px' }}
        aria-label='worktime table 2'
      >
        <TableHead>
          <TableRow>
            <TableCell colSpan={mainTimes.length + 1}>
              <Typography variant='h6' sx={{ fontSize: '1rem' }}>
                Frühe / späte Zeiten
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <HeaderTableCell></HeaderTableCell>
            {earlyTimes.map((slot, index) => (
              <StyledTableCell key={index}>
                <HourDisplay time={slot.time} isHalfHour={slot.time.includes('30')} />
              </StyledTableCell>
            ))}
            <StyledTableCell key={'break'}>{'...'}</StyledTableCell>
            {lateTimes.map((slot, index) => (
              <StyledTableCell key={index}>
                <HourDisplay time={slot.time} isHalfHour={slot.time.includes('30')} />
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <HeaderTableCell>L</HeaderTableCell>
            {earlyTimes.map((slot, index) => (
              <StyledTableCell key={index}>{slot.Arenaleitung}</StyledTableCell>
            ))}
            <StyledTableCell key={'break'}>{'...'}</StyledTableCell>
            {lateTimes.map((slot, index) => (
              <StyledTableCell key={index}>{slot.Arenaleitung}</StyledTableCell>
            ))}
          </TableRow>
          <TableRow>
            <HeaderTableCell>K</HeaderTableCell>
            {earlyTimes.map((slot, index) => (
              <StyledTableCell key={index}>{slot.Kundenbetreuung}</StyledTableCell>
            ))}
            <StyledTableCell key={'break'}>{'...'}</StyledTableCell>
            {lateTimes.map((slot, index) => (
              <StyledTableCell key={index}>{slot.Kundenbetreuung}</StyledTableCell>
            ))}
          </TableRow>
          <TableRow>
            <HeaderTableCell>Σ</HeaderTableCell>
            {earlyTimes.map((slot, index) => (
              <StyledTableCell key={index}>
                <b>{slot.Arenaleitung + slot.Kundenbetreuung}</b>
              </StyledTableCell>
            ))}
            <StyledTableCell key={'break'}>{'...'}</StyledTableCell>
            {lateTimes.map((slot, index) => (
              <StyledTableCell key={index}>
                <b>{slot.Arenaleitung + slot.Kundenbetreuung}</b>
              </StyledTableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WorktimeTimeline;
